import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { throwError } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { SignUpInputModel, SignUpOutputModel } from './../../shared/models/signup.models';
import { GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { ANALYTICS_CONSTANTS } from 'config';
declare var ENV_PORTAL;

@Injectable()
export class SignupService {
  public emmProductCode: any;
  public mdmProductName: any;
  public productDetails: any;
  public ztpAccID: any;

  constructor(private http: HttpClient,
    private httpClientService: HttpClientService,
    private datePipe: DatePipe,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      })
	 ,catchError( this.handleError ));
  }

  pageContent(dataurl) {
    return this.fetchJSON(dataurl);
  }

  pageHtml(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));

  }

  getFANList(companyid) {
    let fanUrl;
    if (this.utilityService.getEnvConfig().useMock) {
      
      //fanUrl = "assets/mock/dashboard/getFANListMock3.json";
      fanUrl = "assets/mock/dashboard/getFANListMock6.json";
      
    } else {
      fanUrl = this.utilityService.getEnvConfig().getFANList;
    }
    return this.fetchJSON(fanUrl);
  }

  getAppList(emmProductCode) {
    let appUrl;   
    appUrl = this.utilityService.getEnvConfig().getAppList + '?emmProductCode=' + emmProductCode;
    
    return this.fetchJSON(appUrl);
  }


  requestPopupContent(id) {
    return this.httpClientService.get(id, this.get_headers())
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  requestSupportContent(id) {
    return this.httpClientService.get(id, this.get_headers())
      .pipe(
       map((res: HttpResponse<any>) => res.body)
      ,catchError( this.handleError ));
  }

  getProfileSettings(companyid, pageSize, pageNumber,emmProductCode) {
    let profileListUrl;
   
      profileListUrl = this.utilityService.getEnvConfig().getprofileList + '?companyId='
                        + companyid + '&emmProductCode=' + emmProductCode + '&pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    
    return this.httpClientService.authorizedGet(profileListUrl)
    .pipe(
       map((test: HttpResponse<any>) => {
      return test.body;
    })
    ,catchError( this.handleError ));
  }

  getAppleSummary() {
      let appleUrl;
      appleUrl = this.utilityService.getEnvConfig().getAppleSummary + '?detail=false';   
      return this.fetchJSON(appleUrl);
  }

  saveSignupModel(inputModel: SignUpInputModel, outputModel: SignUpOutputModel, initialSignup: boolean, isNewProfile: boolean = false) {
    sessionStorage.setItem('SignUpData', JSON.stringify({
      inputModel: inputModel,
      outputModel: outputModel,
      initialSignup: initialSignup,
      isNewProfile: isNewProfile
    }));
  }

  submitSignupOrder(data) {
    return this.httpClientService.post(this.utilityService.getEnvConfig().submitSignup, data, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      })
      ,catchError( this.handleError ));
  }

  createProfile(data) {
    return this.httpClientService.post(this.utilityService.getEnvConfig().createProfile, data, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      })
      ,catchError( this.handleError ));
  }
  emailConfirmation(data) {
    return this.httpClientService.post(this.utilityService.getEnvConfig().emailConfirmation, data, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
  }

  getSignupDataFromModel(inputModel: SignUpOutputModel) {
    let productDetails = {
      'emmProductCode': '',
      'selectedAccID': ''
    };
    if (sessionStorage.getItem('manage-product')) {
      productDetails = JSON.parse(sessionStorage.getItem('manage-product'));
      this.ztpAccID = productDetails.selectedAccID;
      // if(productDetails.emmProductCode == 'DMPSKME') {
      //   productDetails.emmProductCode = 'ADDPSKME';
      // }else if (productDetails.emmProductCode =='DMPGZTE') {
      //   productDetails.emmProductCode = 'ADDPGZTP';
      // }
    }
    return {
      fanList: inputModel.FANList.awaitingSignupFanList.map(item => item.fanId),
      emmProductCode: productDetails.emmProductCode,
      emmAccountId: this.ztpAccID
      /*,
      readTnC: inputModel.readTnC,
      emailTnC: inputModel.emailTnC,
      version: inputModel.version,*/
    };
  }

  updateProfileName(id, newprofileName) {
    // profileID:Q77000000000001066 (valid profile ID which exists in ROME)
    return this.httpClientService.post(this.utilityService.getEnvConfig().
      updateProfileName, { profileID: id, profileName: newprofileName }, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return test.body;
      })
      ,catchError( this.handleError ));
  }

  createZtpAccount(selectedAccID, agreementID) {
    const data = { 'email': selectedAccID, 'agreementId': agreementID };
    // if (!this.utilityService.getEnvConfig().useMock) {
    //   return this.httpClientService.post(this.utilityService.getEnvConfig().createZtpAccountMock, data, this.get_headers())
    //   .pipe(
       map((test: Response) => test.json())
    //   ,catchError( this.handleError ));
    // } else {
    return this.httpClientService.post(this.utilityService.getEnvConfig().createZtpAccount, data, this.get_headers())
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
    // }
  }

  getAutogeneratedProfileName() {
    const date1 = this.datePipe.transform(new Date(), 'MMddyyyy');
    const time2 = new Date();
    const hh = time2.getHours();
    const mm = time2.getMinutes();
    const ss = time2.getSeconds();
    const hh1 = hh < 10 ? '0' + hh : hh;
    const mm1 = mm < 10 ? '0' + mm : mm;
    const ss1 = ss < 10 ? '0' + ss : ss;
    const strTime = '' + hh1 + mm1 + ss1;
    const time1 = strTime;
    const datetime = date1 + time1;
    return datetime;
  }

  getSetupDataFromModel(inputModel: SignUpOutputModel, isNew: boolean, isrevisedFanList) {
    const setupData = {
      deviceEnrollDate: {
        new: this.datePipe.transform(inputModel.deviceEnrollDate.new, 'yyyy-MM-dd'),
        existing: this.datePipe.transform(inputModel.deviceEnrollDate.existing, 'yyyy-MM-dd')
      },
    };
    this.productDetails = JSON.parse(sessionStorage.getItem('manage-product'));
    if (!isNew) {
      setupData['profileId'] = inputModel.profile.profileId;
      setupData['memberdetails'] = inputModel.FANList[this.getSelectedFAN(inputModel.FANList)].map(item => {
        return isrevisedFanList ? { fanid: [item.fanId], groupId: item.groupId } : { fanid: [item.fanId] };
      });
    } else {
      setupData['memberdetails'] = inputModel.FANList[this.getSelectedFAN(inputModel.FANList)].map(item => {
        return { fanid: [item.fanId] };
      });
    }
    setupData['profileName'] = inputModel.profile.profileName;
    setupData['settings'] = [inputModel.profile.settings];
    if (this.productDetails.emmProductCode === 'DMPGZTP' || this.productDetails.emmProductCode === 'DMPSKME') {
      setupData['applications'] = [];
    } else {
      setupData['applications'] = inputModel.profile.applications;
    }
    setupData['emmProductCode'] = this.productDetails.emmProductCode;
    return setupData;
  }

  compareTwoObject = function (obj1, obj2) {
    let result = 0;
    for (const key in obj1) {
      if (key !== 'selected') {
        if(key === 'applications')
        {
          if(obj1[key].length === 0 && obj2[key].length > 0)
           {
            result++;
            break;
           }
        } if (typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
          result += this.compareTwoObject(obj1[key], obj2[key]);
        } else if (obj1.length !== undefined && obj1.length < obj2.length) {
          result++;
          break;
        } else if (obj2[key] !== obj1[key]) {
          result++;
          break;
        }
      }
    }
    return result;
  };

  getSignupModel() {
    return sessionStorage.getItem('SignUpData') ? JSON.parse(sessionStorage.getItem('SignUpData')) : false;
  }

  removeSignupModel() {
    sessionStorage.removeItem('SignUpData');
  }

  handleError = (error) => {
    return throwError(error);
  }

  /* Review and Confirm Common functionality*/
  selectedAppList(appList, selectedAppList) {
    const tmpApp = [];
    appList.forEach(app => {
      if (selectedAppList.indexOf(app.appId) !== -1) {
        tmpApp.push(app.appName);
      }
    });
    return tmpApp;
  }

  initSelectedFanGrid(data, columnDefinitions, showPaginationIndex) {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: data.length
    };

    options.Paginations = pagination;
    options.gridData = data;
    options.columnDefinitions = columnDefinitions;
    options.showPaginationIndex = showPaginationIndex;
    return options;
  }

  getSelectedFAN(FANList) {
    if (FANList.awaitingSignupFanList.length) {
      return 'awaitingSignupFanList';
    } else if (FANList.newSetupFanList.length) {
      return 'newSetupFanList';
    } else if (FANList.revisedFanList.length) {
      return 'revisedFanList';
    }
  }
  getSelectedProdCode() {
    return sessionStorage.getItem('manage-product');
  }

  createPageLoadProperties(url, section1) {
    const dataLayer = {};
    if (url === 'ACCOUNTSFAILURE') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/signup/failuremodal.html';
    } else if (url === 'SETTINGSMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/signup/supportmodal.html';
    } else if (url === 'COFIRMREQUESTMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/signup/confirmrequestmodal.html';
    } else if (url === 'APPLICATIONSMODAL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/signup/applicationsmodal.html';
    } else if (url === 'STARTDATEMODEL') {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = '/virtual/signup/startdatelearnmoremodal.html';
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_SIGNUP_' + url];
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SIGNUP;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = section1;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'home';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }
};